// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../../common/baseQuery';

// initialize an empty api service that we'll inject endpoints into later as needed
export const manualMatchingApi = createApi({
  reducerPath: 'manualMatchingApi',
  baseQuery: baseQueryWithAuth,
  endpoints: () => ({})
});
